import styled from 'styled-components';

export default styled.div`
  color: #738A94;
  font-size: 1.2rem;

  @media (min-width: 550px) {
    font-size: 1.4rem;
  }
 
`;
